import React, { FC, useState } from 'react';
import { LandscapeAboutParticipantAddTemplate } from '../../templates';
import { ParticipantResponseDto } from '../../../store/landscapeAPI/participant/dto/response/participant-response.dto';
import { useNavigate, useParams } from 'react-router-dom';
import { ParticipantSaveRequestDto } from '../../../store/landscapeAPI/participant/dto/request/participant-save-request.dto';
import { getUUID } from '../../../utils/UUID';
import { useDispatch } from 'react-redux';
import { saveParticipant } from '../../../store/landscapeAPI/participant/reducers/participant.slice';
import { AppDispatch } from '../../../store/store';
import { fetchLandscapeById } from '../../../store/landscapeAPI/landscape/reducers/landscape.slice';
import { ParticipantOrganisationType } from '../../../store/landscapeAPI/participant/participant-organisation-type';
import { LocalesLanguagesConstants } from '../../../locales/locales';

interface LandscapeAboutParticipantAddPageProps {}

const LandscapeAboutParticipantAddPage: FC<
  LandscapeAboutParticipantAddPageProps
> = () => {
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const [participant, setParticipant] = useState<ParticipantResponseDto>({
    compactId: id ?? '',
    name: '',
    url: '',
    organisationType: ParticipantOrganisationType.CivilSociety,
    id: getUUID(),
    versionId: 0,
    createdByUserId: '',
    createdOnDateTimeUtc: '',
    language: '',
    published: true,
  });

  const handleOnChange = (participant: ParticipantResponseDto) => {
    setParticipant(participant);
  };

  const callbackFn = async (participant: ParticipantResponseDto) => {
    const participantToSave: ParticipantSaveRequestDto = {
      compactId: participant.compactId,
      name: participant.name,
      url: participant.url,
      organisationType: participant.organisationType,
      id: participant.id,
      published: true,
    };
    await dispatch(saveParticipant(participantToSave));
    if (id) {
      dispatch(
        fetchLandscapeById({ id: id, language: LocalesLanguagesConstants.en })
      );
    }
    navigate(`/landscapes/edit/${id}/about`);
  };

  return (
    <LandscapeAboutParticipantAddTemplate
      handleOnChange={handleOnChange}
      participant={participant}
      callbackFn={callbackFn}
    />
  );
};

export default LandscapeAboutParticipantAddPage;
